import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllLocalEstoqueCadastro } from '../service';
import {
  LIST_LOCAL_ESTOQUE_CADASTRO,
  LIST_LOCAL_ESTOQUE_CADASTRO_PENDING,
  LIST_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
  LIST_LOCAL_ESTOQUE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllLocalEstoqueCadastro(action) {
  yield put({ type: LIST_LOCAL_ESTOQUE_CADASTRO_PENDING })

  try {
    const list = yield call(findAllLocalEstoqueCadastro)
    
    yield put({ type: LIST_LOCAL_ESTOQUE_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_LOCAL_ESTOQUE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllLocalEstoqueCadastro() {
  yield takeLatest(LIST_LOCAL_ESTOQUE_CADASTRO, sagaListAllLocalEstoqueCadastro)
}